const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: "/contact",
    exact: true,
    component: "Contact",
  },
  {
    path: "/privacy-policy",
    exact: true,
    component: "Privacy",
  }
];

export default routes;
